{
  "collect": "மாதிரியை சேகரி",
  "track": "மாதிரியைக் கண்காணி",
  "accession": "சேர்க்கை எண்",
  "barcode": "பட்டை குறியீடு",
  "status": {
    "ordered": "ஆணையிடப்பட்டது",
    "collected": "சேகரிக்கப்பட்டது",
    "inTransit": "போக்குவரத்தில்",
    "received": "பெறப்பட்டது",
    "processing": "செயலாக்கத்தில்",
    "resulted": "முடிவுகள் வந்துள்ளன",
    "rejected": "Rejected",
    "in_transit": "போக்குவரத்தில்"
  },
  "title": "Specimens",
  "loading": "Loading specimens…",
  "errorState": "Could not load specimens.",
  "emptyState": "No specimens for this patient.",
  "noRejectionReason": "Rejected — no reason recorded",
  "columns": {
    "accession": "Accession",
    "type": "Type",
    "status": "Status",
    "collected": "Collected",
    "received": "Received",
    "location": "Location"
  }
}
